const FormBuilderConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	// update each component to integrate custom API field to attach the KID of class
	// this is needed to enable d&d of components in the form builder!
	const KformComponents = KformComponentsProvider.$get();

	for (const component of Object.values(KformComponents.components)) {
		component.children = false;
		component.selectable = true;
	}
};

export default FormBuilderConfig;
